export default __webpack_public_path__ + "static/media/princi.9f805d43.png";